import { useEffect, useState } from "react";
// import { TileLayer } from "leaflet";
// import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import Komentar from "./Komentar";
import UniBtn from "./UniBtn";
import UniImage from "./UniImage";
import { _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3 } from "../utils/zz/zz-yourmap-utils";
import UniSpinnerClassic from "./UniSpinnerClassic";
import UniLimiter from "./UniLimiter";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update } from "../utils/zz/zz-yourmap-routing";
import YourmapCardTeaser from "./YourmapCardTeaser";


// DEFAULT COMPONENT
// TODO NOVO DJUTURE lista...
export const YourmapSectionYmthingList = (props) => {
  const {
    lookup_pack,
    current_destination_entity,
    route_destination_id,
    route_destination_tab,
    ymthing_entities,
    ymthing_entities_fetching,
  } = props.appPack;
  const parent_destinacija_id = route_destination_id; // TODO
  //
  let _naslov_za_list = '';
  let is_tab_default = false;
  if (route_destination_tab === null) {
    is_tab_default = true;
  }
  if (is_tab_default || route_destination_tab === 'smestaji') {
    _naslov_za_list = 'Selekcija smeštaja';
  } else if (route_destination_tab === 'restorani') {
    _naslov_za_list = 'Selekcija restorana';
  } else if (route_destination_tab === 'servisi') {
    _naslov_za_list = 'Selekcija servisa';
  } else if (route_destination_tab === 'prodavnice') {
    _naslov_za_list = 'Selekcija prodavnica';
  } else if (route_destination_tab === 'aktivnosti') {
    _naslov_za_list = 'Selekcija aktivnosti';
  } else if (route_destination_tab === 'znamenitosti') {
    _naslov_za_list = 'Selekcija znamenitosti';
  } else if (route_destination_tab === 'ostalo') {
    _naslov_za_list = 'Ostalo';
  } else if (route_destination_tab === 'blog') {
    _naslov_za_list = 'Blog';
  }
  if (Easy69_v1.is_string_not_empty(current_destination_entity.destinacija_naslov_sufix_za_liste)) {
    _naslov_za_list += ' ' + current_destination_entity.destinacija_naslov_sufix_za_liste;
  }
  const title = _naslov_za_list;
  _zzyourmap_routing_browser_title_update(title);

  //
  const ymthing_entities_of_destination = _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3(ymthing_entities, route_destination_id, route_destination_tab);
  const _unfiltered_entities = ymthing_entities_of_destination;

  //
  console.log('* current_destination_entity', current_destination_entity);
  const [filtersSubdestinations, setFiltersSubdestinations] = useState({});

  // filter by subdestinations
  useEffect(() => {
    setFiltersSubdestinations(state => {
      if (current_destination_entity?.of_id > 0 && Array.isArray(current_destination_entity?._subdestinations)) {
        const updated_state = {};
        current_destination_entity._subdestinations.forEach((subdestination_item) => {
          if (subdestination_item._is_main_subdestionation === true) {
            updated_state[subdestination_item._option_value_regular] = true;
          } else {
            updated_state[subdestination_item._option_value_regular] = true;
          }
        });
        return updated_state;
      } else {
        return {};
      }
    });
  }, [current_destination_entity?.of_id]);
  const filtered_entites_of_destination = _unfiltered_entities.filter((item, index) => {
    if (item.parent_destinacija_id > 0 && filtersSubdestinations?.[item.parent_destinacija_id] === true) {
      return true;
    }
    return false;
  });
  //

  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle">
            <div className="uu-gap-standalone-1rem"></div>
            {/*<h2>Selekcija smeštaja na Zlatiboru</h2>*/}
            {/*<h2>{destinacija_naslov_za_restorane}</h2>*/}
            <h2>{_naslov_za_list}</h2>
            <p>Istraži savete, preporuke i esencijalne informacija za tvoje putovanje {/*na Zlatibor*/}</p>

            <div className="yourmap__filters">
              {
                (Array.isArray(current_destination_entity?._subdestinations)) ? (
                  <>
                    {
                      current_destination_entity._subdestinations.map((item) => {
                        return (
                          <div key={item._option_value_regular} className={"yourmap__filters__item" + (false ? " yourmap__map__subdestinations-selector__option--active" : "")}>
                            <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_image_lib_item_singular'}>
                              <span className="label">{item._option_title}</span>
                              <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                                <input
                                  type="checkbox"
                                  name={'select_image_lib_item'}
                                  readOnly={false}
                                  disabled={false}
                                  checked={filtersSubdestinations?.[item._option_value_regular] === true}
                                  onChange={() => {
                                    setFiltersSubdestinations(state => {
                                      if (state?.[item._option_value_regular] === true) {
                                        return {
                                          ...state,
                                          [item._option_value_regular]: false,
                                        };
                                      } else {
                                        return {
                                          ...state,
                                          [item._option_value_regular]: true,
                                        };
                                      }
                                    });
                                  }}
                                />
                              </span>
                            </label>
                          </div>
                        );
                      })
                    }
                  </>
                ) : (null)
              }
            </div>
            <div className="uu-gap-standalone-8px"></div>

          </div>
          <div className="yourmap__grid yourmap__grid--gaps-1rem yourmap__grid--items-w-1-3">
            {
              // rapidozi_dummysmarty_utils.item_to_arr(null, 4).map((item, index) => {
              filtered_entites_of_destination.map((item, index) => {
                return (
                  <div key={index} className="xi">
                    <YourmapCardTeaser appPack={props.appPack} item={item} />
                  </div>
                );
              })
            }
          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionYmthingList;
